import { makeAutoObservable, runInAction } from 'mobx';
import { IShopType, IShopTypeParams } from 'src/@types/Choqorak/Settings/ShopType';
import agent from 'src/api/agent';
export default class ShopTypeStore {
  openDialog = false;

  ShopTypeRegistry = new Map<number, IShopType>();

  editMode = false; //When click on edit button

  selectedShopType: IShopType | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get ShopTypeList() {
    return Array.from(this.ShopTypeRegistry.values());
  }

  setShopTypeList = (ShopType: IShopType) => {
    this.ShopTypeRegistry.set(ShopType.id!, ShopType);
  };

  //Pagination
  loadShopType = async (params: IShopTypeParams) => {
    // this.ShopTypeRegistry.clear();
    try {
      const result = await agent.ShopType.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setShopTypeList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ShopTypeSearch = async (params: IShopTypeParams) => {
    this.ShopTypeRegistry.clear();
    this.loadShopType(params);
  };

  getShopTypeFromRegistry = (id: number) => {
    let ShopType = this.ShopTypeRegistry.get(id);
    if (ShopType) {
      this.editMode = true;
      this.selectedShopType = ShopType;
    }
  };

  clearSelectedShopType = () => {
    this.editMode = false;
    this.selectedShopType = undefined;
  };

  deleteShopType = async (id: number, remark?: string) => {
    await agent.ShopType.delete(id, remark!);
    runInAction(() => {
      this.ShopTypeRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createShopType = async (ShopType: IShopType) => {
    await agent.ShopType.create(ShopType);
    runInAction(() => {
      this.loadShopType({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedShopType();
    });
  };

  updateShopType = async (ShopType: IShopType) => {
    await agent.ShopType.update(ShopType);

    runInAction(() => {
      this.loadShopType({ pageIndex: 0, pageSize: 5 });
      this.ShopTypeRegistry.delete(ShopType.id!);
      this.ShopTypeRegistry.set(ShopType.id!, ShopType);
      this.clearSelectedShopType();
    });
  };
}
